import React from "react";
import Layout from "../components/layout";
import "./about.css";

const cards = [
  {
    title: "Why Choose Us",
    content:
      "TRESCORP manages the sourcing and procurement of crude oil and petroleum products, overseeing all supply chain activities, from sourcing and transportation to storage and processing.",
  },
  {
    title: "Our Vision",
    content:
      "TRESCORP's vision is to be the preferred oil and gas business solution provider for the downstream supply chain.",
  },
  {
    title: "Our Mission",
    list_content: [
      "To provide attractive business alternatives that enhance value for our partners.",
      "To ensure all our business ventures generate attractive returns.",
      "To provide solutions, dedicated support, and ensure client satisfaction, fostering sustainable business growth.",
    ],
  },
];

const strengths = [
  {
    iconClass: "fa-solid fa-handshake",
    iconSize: "x-large",
    text: "We are appointed by the Ministry of Energy and Minerals of the Sultanate of Oman to market, sell, and distribute their crude oil.",
  },
  {
    iconClass: "fa-solid fa-bolt",
    iconSize: "xx-large",
    text: "We process and market our own petroleum products, including gasoline, gasoil (diesel), fuel oil and LPG.",
  },
  {
    iconClass: "fa-solid fa-oil-well",
    iconSize: "x-large",
    text: "We trade fuel oil, crude oil, LNG, LPG, and gas oil.",
  },
  {
    iconClass: "fa-solid fa-industry",
    iconSize: "x-large",
    text: "Constructing and managing crude and fuel oil storage facilities in Oman.",
  },
  {
    iconClass: "fa-solid fa-bullseye",
    iconSize: "x-large",
    text: "Since 2017, we have held a term allocation for Oman Export Blend, sourced directly from the Ministry of Energy and Minerals of the Sultanate of Oman.",
  },
  {
    iconClass: "fa-solid fa-globe",
    iconSize: "x-large",
    text: "Trescorp's strength lies in sourcing and procuring crude oil, LNG, and petroleum products. We distribute these products throughout Asia at competitive terms.",
  },
];

const sectionHeadingClass = "btm about-section-heading text-4xl sm:text-5xl mb-6";

const StrengthItem = ({ item }) => (
  <div className="flex items-start gap-4 mb-2">
    <div className="pentagon flex-shrink-0">
      <span className="elementor-icon elementor-animation">
        <i
          className={item.iconClass}
          style={{
            fontSize: item.iconSize,
            marginTop: item.iconSize === "xx-large" ? "0.5rem" : "0.8rem",
          }}
        />
      </span>
    </div>
    <div className="mt-2 flex-1">
      <p className="text-black font-bold text-left break-words leading-snug">{item.text}</p>
    </div>
  </div>
);

const About = () => {
  const leftStrengths = strengths.slice(0, 3);
  const rightStrengths = strengths.slice(3);

  return (
    <Layout>
      <main>
        <div className="overflow-hidden">
          <section
            className="container mx-auto max-w-none text-gray-600 body-font md:my-auto relative bg-black"
            aria-labelledby="about-page-title"
          >
            <div className="absolute inset-0 bg-gray-800 opacity-70">
              <div
                className="w-full h-full bg-cover bg-center"
                style={{ backgroundImage: "url('../img/2968.jpg')" }}
              />
            </div>
            <div className="relative flex flex-wrap -m-4 mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
              <div className="my-20 sm:my-5 md:my-20">
                <h1
                  id="about-page-title"
                  className="ekit-heading__shadow-text2 text-white transition-all duration-300 inline-block font-bold text-4xl md:text-6xl lg:text-7xl"
                >
                  About Us
                </h1>
              </div>
            </div>
          </section>

          <section className="container text-gray-600 body-font mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-40 md:my-5">
            <div className="flex flex-wrap -m-4 mt-5">
              <div className="p-4 w-full md:w-2/5">
                <img
                  className="object-cover object-center rounded-md w-full h-full hover:transform hover:-translate-y-2 hover:translate-x-2 transition duration-300"
                  alt="Trescorp office and business context"
                  src="../img/about1-1.jpg"
                  style={{ minHeight: "260px" }}
                />
              </div>
              <div className="p-4 w-full md:w-3/5">
                <div className="px-0 mx-auto text-center md:text-left">
                  <p className="text-lg leading-relaxed mb-4">
                    <b>Trescorp Alliance Pte Ltd (Trescorp)</b> is a trading company which focuses
                    on crude oil and petroleum products from its headquarters in Singapore and The
                    Sultanate of Oman.
                  </p>
                  <p className="text-lg leading-relaxed">
                    We specialize in sourcing and trading of crude oil, LNG and refined petroleum
                    products on a global scale. We have established reliable supply direct from
                    source. We channel sales through our extensive networks internationally. We are
                    a complete end to end supply chain provider.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="container text-gray-600 body-font mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-40 md:my-5">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {cards.map((card) => (
                <div key={card.title} className="flex flex-col h-full">
                  <div
                    className="rounded-lg p-6 flex flex-col h-full shadow-sm hover:shadow-md transition-shadow"
                    style={{ border: "1px solid rgb(229, 230, 234)" }}
                  >
                    <h3 className="text-xl font-bold mb-4 min-h-[3.5rem] flex items-center justify-center text-center">
                      {card.title}
                    </h3>
                    {card.content && (
                      <p className="text-gray-600 leading-relaxed flex-grow">{card.content}</p>
                    )}
                    {card.list_content && (
                      <ul className="space-y-2 flex-grow">
                        {card.list_content.map((item) => (
                          <li key={item} className="text-gray-600 leading-relaxed flex items-start">
                            <span className="mr-2 text-gray-800">{"\u2022"}</span>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="container text-gray-600 body-font mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-40 md:my-5">
            <div className="flex flex-wrap -m-4">
              <div className="p-4 md:w-full">
                <div className="text-center md:text-left">
                  <h1
                    className={sectionHeadingClass}
                    style={{ textTransform: "capitalize", fontWeight: "500" }}
                  >
                    Our Strengths
                  </h1>
                </div>
              </div>
              <div className="p-4 w-full md:w-1/2">
                <div className="grid grid-cols-1 gap-6 my-0">
                  {leftStrengths.map((item) => (
                    <StrengthItem key={item.text} item={item} />
                  ))}
                </div>
              </div>
              <div className="p-4 w-full md:w-1/2">
                <div className="grid grid-cols-1 gap-6 my-0">
                  {rightStrengths.map((item) => (
                    <StrengthItem key={item.text} item={item} />
                  ))}
                </div>
              </div>
            </div>
          </section>

          <section className="container text-gray-600 body-font mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-40 md:my-5">
            <div className="flex flex-wrap -m-4">
              <div className="p-4 w-full md:w-2/5 order-2 md:order-1">
                <img
                  className="object-cover object-center rounded-md w-full h-full hover:transform hover:-translate-y-2 hover:translate-x-2 transition duration-300"
                  alt="Ethics and compliance"
                  src="../img/ethis.png"
                />
              </div>
              <div className="p-4 w-full md:w-3/5 order-1 md:order-2">
                <div className="text-left">
                  <h1
                    className={sectionHeadingClass}
                    style={{ textTransform: "capitalize", fontWeight: "500" }}
                  >
                    Ethics and compliance
                  </h1>

                  <p className="mb-4 leading-relaxed">
                    At TRESCORP, we are committed to maintaining a high standard of ethical practice
                    in our Responsible Business Conduct (RBC) on a global scale. We are committed to
                    creating a legacy of home-grown skill development by integrating local
                    professionals in our projects, providing sustained economic opportunity in the
                    communities where we operate. Furthermore by volunteering our time and talent
                    locally, we actively build a diverse, inclusive, and collaborative work
                    environment where all views are welcomed, honesty is encouraged, and teamwork
                    and distinction are cornerstones. We are proud of what we do and how we do it,
                    and we enjoy doing it! Our ethical standard is one of our most valued assets.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </Layout>
  );
};

export default About;
